import { useMutation } from '@tanstack/react-query'

import { updateRadAffectedStaff } from '../../../api/rads/update-rad-affected-staff'
import { showAxiosError } from '../../../lib/utils/functions/misc.functions'
import UpdateCommentForm from '../../elements/update-comment-form'

type Props = {
  radId: number
  participantId: number
  className?: string

  onSuccess: () => void
  onCancel: () => void
}

const UpdateRadCommentForm = ({ radId, participantId, className, onSuccess, onCancel }: Props) => {
  const { mutateAsync } = useMutation({
    mutationFn: updateRadAffectedStaff,
    onError: showAxiosError,
    onSuccess
  })

  return (
    <UpdateCommentForm
      className={className}
      onCancel={onCancel}
      onSuccess={async (comment) => {
        await mutateAsync({ id: radId, participantId, radComment: comment })
      }}
    />
  )
}

export default UpdateRadCommentForm
